import { RiHeartFill } from 'react-icons/ri'

import './FavButton.css'

function FavButton({favorite, handleClick}) {
  return (
    <button type='button' className={`btn_fav ${favorite ? 'active' : ''}`} onClick={handleClick}>
        <RiHeartFill />
    </button>
  )
}

export default FavButton